import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";


export const OkIcon = (props) => {
    const style = props;
    return (
        <FontAwesomeIcon icon={"check-circle"} style={{color: "#519c16", ...style}} />
    )
};

export const WarnIcon = (props) => {
    const style = props;
    return (
        <FontAwesomeIcon icon={"exclamation-triangle"} style={{color: "#f9ca06", ...style}}/>
    )
};

export const ErrorIcon = (props) => {
    const style = props;
    return (
        <FontAwesomeIcon icon={"exclamation-circle"} style={{color: "#cc0000", ...style}}/>
    )
};

export const NoIcon = (props) => {
    const style = props;
    return (
        <FontAwesomeIcon icon={"ban"} style={{...style}}/>
    )
};

export const StatusIcon = (props) => {
    switch (props.status.toUpperCase()) {
        case 'PRODUCTION':
            return <OkIcon marginRight={"5px"}/>;
        case 'DEVELOPMENT':
            return <WarnIcon marginRight={"5px"}/>;
        default:
            return <ErrorIcon marginRight={"5px"}/>;
    }
};

export const ParamEnabledIcon = (props) => {
    switch (props.enabled) {
        case true:
            return <OkIcon marginRight={"5px"}/>;
        case false:
            return <ErrorIcon marginRight={"5px"}/>;
    }
};



// WEBPACK FOOTER //
// ./src/components/Icons.js